"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getAddressObject(addressComponents) {
    const componentOptions = {
        streetNumber: ['street_number'],
        postalCode: ['postal_code'],
        streetName: ['street_address', 'route'],
        region: [
            'administrative_area_level_1',
            'administrative_area_level_2',
            'administrative_area_level_3',
            'administrative_area_level_4',
            'administrative_area_level_5',
        ],
        city: [
            'locality',
            'sublocality',
            'sublocality_level_1',
            'sublocality_level_2',
            'sublocality_level_3',
            'sublocality_level_4',
        ],
        country: ['country'],
        subPremise: ['subpremise'],
    };
    let address = {
        streetNumber: '',
        postalCode: '',
        streetName: '',
        region: '',
        city: '',
        country: '',
        subPremise: '',
    };
    addressComponents.forEach(component => {
        for (let option in componentOptions) {
            if (componentOptions[option].indexOf(component.types[0]) >= 0) {
                address[option] = component.long_name;
            }
        }
    });
    return address;
}
exports.getAddressObject = getAddressObject;
